import { render, staticRenderFns } from "./ManageCosts.vue?vue&type=template&id=6be36571&scoped=true&"
import script from "./ManageCosts.vue?vue&type=script&lang=js&"
export * from "./ManageCosts.vue?vue&type=script&lang=js&"
import style0 from "./ManageCosts.vue?vue&type=style&index=0&id=6be36571&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be36571",
  null
  
)

export default component.exports